import { AxiosInstance } from 'axios'

import { apiPaths } from '@percent/partner-dashboard/services/apiPaths'
import {
  PartnerConfigData,
  PartnerConfigKey
} from '@percent/partner-dashboard/context/config/PartnerConfigProvider.types'
import { PBPGetResponse } from '@percent/partner-dashboard/services/types/pbpResponses.types'

type PartnerServiceCapabilities = {
  percentClient: AxiosInstance
}

export const partnerService = ({ percentClient }: PartnerServiceCapabilities) => ({
  get: () => percentClient.get(`${apiPaths.v1Auth}/partners`),
  getConfig: (key: PartnerConfigKey) =>
    percentClient.get<PBPGetResponse<PartnerConfigData>>(`${apiPaths.v1Partner}giving/config/${key}`),
  createKeySet: ({ partnerId, name }: { partnerId: string; name: string }) =>
    percentClient.post(`${apiPaths.v1Partners}${partnerId}/key-set`, { name }),
  editKeySet: ({
    partnerId,
    keySetId,
    payload
  }: {
    partnerId: string
    keySetId: string
    payload: { name?: string; expiresAt?: string }
  }) => percentClient.patch(`${apiPaths.v1Partners}${partnerId}/key-set/${keySetId}`, payload)
})
